import React from 'react';
import { RightMenu } from "../../components/Menu";

const RightNav = ({ path, children }) => {
    return <RightMenu path={path} manualOpen={false}>
      {children}
    </RightMenu>;
}

export default RightNav;